/**
 * Google Maps Extended Routes
 *
 * Declares two web-accessible-resource entries. The first — the `i18n_messages/` JSON
 * and the vendor-named `stencil/assets/` SVGs — is scoped to Google's search/maps
 * origins, so it cannot be reached from an arbitrary page. The second entry exposes
 * `pages/bookmarks/bookmarks.html` to every origin (<all_urls>) with no
 * `use_dynamic_url` — so that one page is fetchable from any page at a fixed URL, which
 * is enough to detect the extension anywhere.
 *
 * Manifest verified against version 1.8.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'okeampldbdmpachkggljgpngbooaclal';

export const googleMapsExtendedRoutes: ExtensionDefinition = {
  id: ID,
  name: 'Google Maps Extended Routes',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 7_000,
  notes:
    'Most WAR are scoped to Google origins, but pages/bookmarks/bookmarks.html is ' +
    'exposed to every origin with no dynamic URL, so one fetch detects it anywhere.',
  signals: [
    {
      id: 'war-bookmarks-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch pages/bookmarks/bookmarks.html — the one WAR matched to every origin at ' +
        'a fixed URL, independent of the Google-scoped resources.',
      weight: 1,
      run: () => probeFetch(ID, 'pages/bookmarks/bookmarks.html'),
    },
  ],
};
